export default __webpack_public_path__ + "upload/inst.cf0911ed.svg";